import { FC } from 'react';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import cn from 'classnames';

import { IUpDownButtonProps } from './UpDownButton.interface';

const UpDownButton: FC<IUpDownButtonProps> = ({ className, open = true, onOpen }) => (
  <IconButton
    className={cn('up-down-button', className)}
    aria-label="expand row"
    size="small"
    onClick={onOpen}
  >
    {open ? <KeyboardArrowUp color="success" /> : <KeyboardArrowDown color="success" />}
  </IconButton>
);

export default UpDownButton;
